/**
 * External dependencies
 */
import styled from '@emotion/styled';

/**
 * Internal dependencies
 */
import { VStack } from '../../v-stack';

export const Wrapper = styled( VStack )`
	box-sizing: border-box;
`;

export const CalendarHelp = styled.div`
	min-width: 260px;
`;
